import { computeUtilityTotalUsageKwh } from '../utility/usage';

export const resolveTargetProductionSettings = ({
  useTargetProduction,
  targetProductionKwh,
  utility,
  iframeContext
} = {}) => {
  const hasSavedSettings =
    useTargetProduction !== undefined && useTargetProduction !== null
      ? true
      : targetProductionKwh !== undefined &&
        targetProductionKwh !== null &&
        Number(targetProductionKwh) > 0;
  const utilityTotalUsageKwh = computeUtilityTotalUsageKwh(utility);
  const defaultTargetProductionKwh =
    Number.isFinite(Number(utilityTotalUsageKwh)) &&
    Number(utilityTotalUsageKwh) > 0
      ? Math.round(Number(utilityTotalUsageKwh))
      : 0;
  const targetNumber = Number(targetProductionKwh);
  const hasPositiveTarget =
    targetProductionKwh !== undefined &&
    targetProductionKwh !== null &&
    targetProductionKwh !== '' &&
    Number.isFinite(targetNumber) &&
    targetNumber > 0;
  const persistedTargetProductionKwh = hasPositiveTarget
    ? targetNumber
    : defaultTargetProductionKwh;
  const persistedUseTargetProduction = hasSavedSettings
    ? Boolean(useTargetProduction) || Number(persistedTargetProductionKwh) > 0
    : true;
  const hasIframeTargetProduction =
    iframeContext &&
    Object.prototype.hasOwnProperty.call(iframeContext, 'targetProduction');
  const iframeTargetProduction = hasIframeTargetProduction
    ? Number(iframeContext.targetProduction)
    : null;
  const iframeTargetIsPositive =
    Number.isFinite(iframeTargetProduction) && iframeTargetProduction > 0;

  return {
    useTargetProduction: hasIframeTargetProduction
      ? iframeTargetIsPositive
      : persistedUseTargetProduction,
    targetProductionKwh: hasIframeTargetProduction
      ? iframeTargetIsPositive
        ? iframeTargetProduction
        : 0
      : persistedTargetProductionKwh,
    defaultTargetProductionKwh,
    hasSavedSettings
  };
};
